export const SETTING_CONFIG_MODEL ={
    enableOtp: false,
    hasApplication: false,
    set: function (data) {
        return {
            ...this,
            enableOtp:data?.enableOtp,
            hasApplication:data?.hasApplication
        }
    },
    toRegister: function () {
        return {
            enableOtp:this.enableOtp,
            hasApplication:this.hasApplication
        }
    },
}


export const SYSTEM_CONFIG_LIST = {
    environmentUrl:"environmentUrl",
    enableOtp:"enableOtp",
    hasApplication:"hasApplication"
}
